export const Supplier = {
    acronym: '',
    address: '',
    comment: null,
    supplierCompanyName: '',
    supplierStatusId: '',
    createdAt: null,
    description: '',
    deviceId: null,
    dob: null,
    email: null,
    firebaseId: null,
    genderId: '',
    id: null,
    lastName: '',
    name: '',
    password: null,
    phoneNumber: '',
    secondLastName: '',
    selfie: null,
    statusId: '',
    updatedAt: null,
    userId: null,
    documentId: '',
    serviceTypeId: '',

    toCreateUpdate: function (password) {
        return {
            acronym: this.acronym,
            address: this.address !== '' ? this.address : null,
            supplierCompanyName: this.supplierCompanyName,
            supplierStatusId: this.supplierStatusId !== '' ? this.supplierStatusId : null,
            description: this.description !== '' ? this.description : null,
            dob: this.dob === null ? null : typeof this.dob === 'number' ? this.dob : this.dob.getTime(),
            email: this.email,
            genderId: this.genderId !== '' ? this.genderId : null,
            id: this.id,
            lastName: this.lastName,
            name: this.name,
            phoneNumber: this.phoneNumber,
            secondLastName: this.secondLastName !== '' ? this.secondLastName : null,
            statusId: this.statusId !== '' ? this.statusId : null,
            userId: this.userId,
            documentId: this.documentId,
            serviceTypeId: this.serviceTypeId,
            password:  password
        };
    },
    isValid: function (){
        return this.acronym &&
            this.supplierCompanyName &&
            this.name &&
            this.lastName &&
            this.phoneNumber &&
            this.documentId &&
            this.serviceTypeId;
    },
    isValidCompanyDetails: function (){
        return this.acronym && this.supplierCompanyName && this.serviceTypeId
    },
    isValidManagerDetails: function (){
        return this.name &&
            this.lastName &&
            this.documentId &&
            this.email &&
            this.phoneNumber;
    },
    clearCompanyDetails: function (){
        return {
            ...this,
            acronym: '',
            supplierCompanyName: '',
            address: '',
            serviceTypeId: '',
            description: ''
        }
    },
    clearManagerDetails: function (){
        return {
            ...this,
            name: '',
            lastName: '',
            secondLastName: '',
            documentId: '',
            email: '',
            phoneNumber:'',
            genderId:'',
            dob: null,
            password:''
        }
    }
};
